var AutohideDirective = require('./AutohideDirective.js');

angular
  .module('saturn-autohide', [])
  .directive('sbAutohide', AutohideDirective);



//////////////////
// WEBPACK FOOTER
// ./~/@skycatch/saturn-autohide-booster/src/index.js
// module id = 770
// module chunks = 0